// packages/hooks/useUsers.ts (ou dans ton app)
import { userService } from "@cabukaka/services";
import { QueryFilters, User } from "@cabukaka/types";
import { useData } from "../core/useData";

export function useUsers(initialFilters?: QueryFilters) {
    // 1. On utilise le hook générique pour le gros du travail
    const {
        data: users,
        loading,
        error,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems
    } = useData<User>({
        ...userService,
        ...userService.baseService
    }, initialFilters);

    const verifyUser = async (id: string) => {
        try {
            updateItem({ isVerified: true, id })
        } catch (error) {
            throw error
        }
    }

    return {
        users,
        loading,
        error,
        refresh,
        deleteUser: deleteItem,
        updateUser: updateItem,
        deleteManyUsers: deleteManyItems,
        verifyUser
    };
}